export var allLocales = (function () {
    var mapping = {
        en: 'en',
        de: 'de',
        es: 'es',
        fr: 'fr',
    };
    return Object.values(mapping);
})();
